<div layout margin-top-small-x>
  @for (holder of placeholders; track trackByIndex(i); let i = $index) {
    <div [class.error]="error" class="wrap">
      <input
        #input
        (click)="onClick(i)"
        (input)="onInput($event, i)"
        (paste)="onPaste($event, i)"
        (keydown)="onKeydown($event, i)"
        type="number"
        autocomplete="one-time-code"
      />
    </div>
  }
</div>

@if (error) {
  <div class="error-message" margin-top-small-x>
    {{ error.error[0] }}
  </div>
}
